import axios from "../AxiosInstance"



const getCarsAPI = async (id) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: id ? `/api/cars?id=${id}` : `/api/cars`,
            method: "GET",
        })
 
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }
    
   
    return resolved
}

const addCarAPI = async (data) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/cars`,
            method: "POST",
            data: {
                ...data.primaryData,
                paintsWheels: data.paintData,
                interior: data.interiorData
            }
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

const editCarAPI = async (id, data) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/cars?id=${id}`,
            method: "PUT",
            data: {
                ...data.primaryData,
                paintsWheels: data.paintData,
                interior: data.interiorData
            }
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

const deleteCarAPI = async (id) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/cars?id=${id}`,
            method: "DELETE",
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

export { getCarsAPI, addCarAPI, editCarAPI, deleteCarAPI }